package com.eladfinish.bible.contest.screens.search.ai

interface GetAiSearchSuggestionUseCase {
    suspend operator fun invoke(
        prompt: String,
    ): Result<AiSearchSuggestion>
}

class GetAiSearchSuggestionUseCaseImpl(
    private val repository: AiSearchRepository,
) : GetAiSearchSuggestionUseCase {

    override suspend fun invoke(
        prompt: String,
    ): Result<AiSearchSuggestion> {


        val normalizedPrompt = prompt
            .trim()
            .replace(Regex("\\s+"), " ")

        if (normalizedPrompt.isEmpty()) {
            return Result.failure(
                IllegalArgumentException("Prompt must not be empty"),
            )
        }

        return repository.getAiSearchSuggestion(
            prompt = normalizedPrompt,
        )
    }
}
